/**
 * MarketplaceBrowser - Navegador de produtos do marketplace com filtros
 * 
 * Extraído do App.js durante refatoração Fase 1
 * 
 * Funcionalidades:
 * - Filtro por categorias de produtos
 * - Grid de produtos filtrados usando MarketplaceItemCard
 * - Mensagem de lista vazia
 * 
 * Dependências:
 * - useTranslation (traduções)
 * - Button (shadcn/ui)
 * - Icons (lucide-react)
 * - MarketplaceItemCard (componente extraído)
 */

import React, { useState } from "react";
import { Button } from "./ui/button";
import { Package, Home, Wrench, Zap, Truck, MoreHorizontal } from "lucide-react";
import { useTranslation } from "../translations";
import MarketplaceItemCard from "./MarketplaceItemCard";

const MarketplaceBrowser = ({ items }) => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const { t } = useTranslation();
  
  const categories = [
    { value: "all", label: t('allProducts'), icon: Package },
    { value: "propriedades", label: t('properties'), icon: Home },
    { value: "ferramentas", label: t('tools'), icon: Wrench },
    { value: "insumos", label: t('supplies'), icon: Package },
    { value: "defensivos", label: t('pesticides'), icon: Zap },
    { value: "maquinaria", label: t('machinery'), icon: Truck },
    { value: "outros", label: t('others'), icon: MoreHorizontal }
  ];

  const filteredItems = selectedCategory === "all" 
    ? items 
    : items.filter(item => item.category === selectedCategory);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold mb-4">{t('marketplace')}</h2>
        <div className="flex flex-wrap gap-2">
          {categories.map((category) => {
            const IconComponent = category.icon;
            return (
              <Button
                key={category.value}
                variant={selectedCategory === category.value ? "default" : "outline"}
                onClick={() => setSelectedCategory(category.value)}
                className="flex items-center space-x-2"
              >
                <IconComponent className="w-4 h-4" />
                <span>{category.label}</span>
              </Button>
            );
          })}
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredItems.map((item) => (
          <MarketplaceItemCard key={item.id} item={item} />
        ))}
      </div>

      {filteredItems.length === 0 && (
        <p className="text-gray-500 text-center py-8">
          {selectedCategory === "all" 
            ? t('noProductsAvailableNow') 
            : t('noProductsInCategory')}
        </p>
      )}
    </div>
  );
};

export default MarketplaceBrowser;
